




import { Vue, Component } from 'vue-property-decorator'
import Templates from '@/pages/Pages/Templates/Templates.vue';
import { MsgTransports } from '@/store/types';
import IncomingTariffs from "@/pages/Pages/Tarification/IncomingTariffs.vue";

@Component({components: {IncomingTariffs, Templates}})
export default class SmsIncomingTariffs extends Vue {
  private transport: MsgTransports = MsgTransports.SMS;
}
